import { render, staticRenderFns } from "./discount-add-goods.vue?vue&type=template&id=4431201c&scoped=true&"
import script from "./discount-add-goods.vue?vue&type=script&lang=js&"
export * from "./discount-add-goods.vue?vue&type=script&lang=js&"
import style0 from "./discount-add-goods.vue?vue&type=style&index=0&id=4431201c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431201c",
  null
  
)

export default component.exports